/**
 * Handle Animations
 */

import { $window } from '../utils/globals.js';

const handleAnimations = () => {
  const winH = $window.height();

  function animate(winST) {
    $('.animations').each(function(){
      if (winST + winH * 0.95 > $(this).offset().top) {
        const animClass = $(this).data('animation');

        if ( !$(this).hasClass('animated') ) {
          $(this).addClass( 'animated' );
          $(this).addClass( animClass );
        }
      }
    });
  };

  const animatedTiles = (winST) => {
      $('.js-tiles-group').each(function(){
          const $this = $(this);

          if (winST + winH * 0.95 > $this.offset().top) {
                setTimeout(function() {
                  $this.addClass('is-active');
                }, 1000);

                setTimeout(function() {
                  $this.addClass('is-completed');
                }, 2500);
          }
      });
  };

  $window.on('load scroll', function() {
    let winST = $window.scrollTop();

    animate(winST);
    animatedTiles(winST);
  });
}

handleAnimations();
